import { ApiBaseService } from './ApiBaseService';

export const MAINTENANCE_BANNER_KEY = 'maintenance_banner';

export interface FeatureFlag {
  id: string;
  key: string;
  enabled: boolean;
  description: string | null;
}

export interface FeatureFlagListResponse {
  status: string;
  data: FeatureFlag[];
}

export interface FeatureFlagSingleResponse {
  status: string;
  data: FeatureFlag;
}

class FeatureFlagsService {
  static async getAll(): Promise<FeatureFlag[]> {
    const response =
      await ApiBaseService.get<FeatureFlagListResponse>('/feature-flags');
    return Array.isArray(response.data) ? response.data : [];
  }

  static async setEnabled(
    key: string,
    enabled: boolean,
  ): Promise<FeatureFlagSingleResponse> {
    return ApiBaseService.patch<FeatureFlagSingleResponse>(
      `/feature-flags/${key}`,
      { enabled },
    );
  }
}

export default FeatureFlagsService;
